import { css } from '../../theme-provider';
export const LENTILS_MAX_LENGHT = 7;
export const LENTILS_MIDDLE_INDEX = Math.floor(LENTILS_MAX_LENGHT / 2);
export const LENTIL_SIZE = ({ theme }) => theme.size.static150;
export const LENTIL_GAP = ({ theme }) => theme.size.static150;
export function lentilsTransform({ activeIndex, length, }) {
    if (length <= LENTILS_MAX_LENGHT) {
        return css `transform:translateX(0);`;
    }
    if (activeIndex >= length - (LENTILS_MIDDLE_INDEX + 1)) {
        return css `transform:translateX(\n\t\t\t\tcalc(\n\t\t\t\t\t${({ theme }) => (theme.direction === 'rtl' ? 1 : -1)} *\n\t\t\t\t\t\t(${LENTIL_SIZE} + ${LENTIL_GAP}) * ${length - LENTILS_MAX_LENGHT}\n\t\t\t\t)\n\t\t\t);`;
    }
    if (activeIndex > LENTILS_MIDDLE_INDEX) {
        return css `transform:translateX(\n\t\t\t\tcalc(\n\t\t\t\t\t${({ theme }) => (theme.direction === 'rtl' ? 1 : -1)} *\n\t\t\t\t\t\t(${LENTIL_SIZE} + ${LENTIL_GAP}) *\n\t\t\t\t\t\t${activeIndex - LENTILS_MIDDLE_INDEX}\n\t\t\t\t)\n\t\t\t);`;
    }
    return css `transform:translateX(0);`;
}
export function lentilsWidth({ length }) {
    return css `width:calc(${length} * ${LENTIL_SIZE} + ${length - 1} * ${LENTIL_GAP});`;
}
export function lentilsHeigth() {
    return css `height:calc(2 * ${LENTIL_SIZE});`;
}
export function lentilsMaxWith() {
    return css `max-width:calc(\n\t\t\t${LENTILS_MAX_LENGHT} * ${LENTIL_SIZE} + ${LENTILS_MAX_LENGHT - 1} *\n\t\t\t\t${LENTIL_GAP} + (${LENTIL_SIZE} * 2 - ${LENTIL_SIZE})\n\t\t);`;
}
export function getRef(index, activeIndex, length, prevRef, nextRef) {
    if (activeIndex === 0 && index === length - 1) {
        return prevRef;
    }
    if (activeIndex === length - 1 && index === 0) {
        return nextRef;
    }
    if (index === activeIndex - 1) {
        return prevRef;
    }
    if (index === activeIndex + 1) {
        return nextRef;
    }
    return undefined;
}
export function isSmall(currentIndex, activeIndex, slideLength) {
    const isCorrected = slideLength > LENTILS_MAX_LENGHT;
    return isCorrected
        ? (activeIndex > LENTILS_MIDDLE_INDEX &&
            currentIndex < activeIndex - (LENTILS_MIDDLE_INDEX - 1) &&
            currentIndex < slideLength - (LENTILS_MAX_LENGHT - 1)) ||
            (currentIndex >= LENTILS_MAX_LENGHT - 1 &&
                currentIndex < slideLength - 1 &&
                currentIndex > activeIndex + (LENTILS_MIDDLE_INDEX - 1))
        : false;
}
